/**
 * rem 适配方案
 * 根据屏幕宽度动态设置根字体大小
 * 设计稿基准：1920x923
 */

interface RemAdapterOptions {
  designWidth: number;    // 设计稿宽度
  designHeight: number;   // 设计稿高度
  baseSize: number;       // 基准字体大小（1rem = baseSize px）
  maxWidth?: number;      // 最大宽度限制
  minWidth?: number;      // 最小宽度限制
}

class RemAdapter {
  private options: RemAdapterOptions;

  constructor(options: RemAdapterOptions) {
    this.options = {
      maxWidth: 3840,  // 支持 4K 显示器
      minWidth: 1280,  // 最小支持 1280px
      ...options,
    };
  }

  /**
   * 初始化 rem 适配
   */
  init() {
    this.setRem();
    window.addEventListener('resize', () => this.setRem());
    
    // 监听 DOMContentLoaded 确保页面加载完成后再设置
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setRem());
    }
  }

  /**
   * 设置根元素字体大小
   */
  setRem() {
    const { designWidth, baseSize, maxWidth, minWidth } = this.options;
    
    // 获取当前屏幕宽度
    let clientWidth = document.documentElement.clientWidth || window.innerWidth;
    
    // 限制最大最小宽度
    if (maxWidth && clientWidth > maxWidth) {
      clientWidth = maxWidth;
    }
    if (minWidth && clientWidth < minWidth) {
      clientWidth = minWidth;
    }
    
    // 计算根字体大小
    // 公式：当前宽度 / 设计稿宽度 × 基准字体大小
    const fontSize = (clientWidth / designWidth) * baseSize;
    
    // 设置根元素字体大小
    document.documentElement.style.fontSize = `${fontSize}px`;
    
    // 设置 body 字体大小为 14px（避免继承根字体大小）
    document.body.style.fontSize = '14px';
    
    console.log(`[RemAdapter] 屏幕宽度: ${clientWidth}px, 根字体大小: ${fontSize.toFixed(2)}px, 缩放比例: ${(fontSize / baseSize * 100).toFixed(2)}%`);
  }

  /**
   * 销毁监听器
   */
  destroy() {
    window.removeEventListener('resize', () => this.setRem());
  }
}

export default RemAdapter;
